import VersionControl from './component'

export default VersionControl
